import React, { useState } from "react";
import UploadForm from "./components/UploadForm";
import DownloadForm from "./components/DownloadForm";
import TableDetails from "./components/TableDetails";




export default function FormLayoutBulkImport({formTitle }) {

    return (
        <>
            <DownloadForm  title={formTitle}/>
            <UploadForm title={formTitle}/>
            <TableDetails/>
        </>
    );
}
